import { render, staticRenderFns } from "./ProjectViewersPopup.vue?vue&type=template&id=a79186a0&scoped=true"
import script from "./ProjectViewersPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectViewersPopup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProjectViewersPopup.vue?vue&type=style&index=0&id=a79186a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79186a0",
  null
  
)

export default component.exports